import { useUserBusinessDetails } from '@ukpostbox/client-data';
import {
	Card,
	CardLayoutType,
	ContentBlock,
	ContentLoader,
	FlexAlign,
	FlexGap,
	FlexJustify,
	StackHorizontal,
	StackVertical,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect } from 'react';
import { SettingsActionType } from '../../Types/SettingsTypes';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function BusinessDetails() {
	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();

	const {
		status,
		data,
		error,
	}: {
		status: any;
		data: any;
		error: any;
		isFetching: any;
	} = useUserBusinessDetails();

	useEffect(() => {
		updatePageMeta({
			title: t(`settings.sections.${'Business Details'}`),
		});
	}, [currentLocale]);

	return (
		<>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-md'>
				<h2 className='mb-0'>{t(`settings.sections.${'Business Details'}`)}</h2>
			</StackHorizontal>

			<StackVertical gap={FlexGap.ExtraLarge}>
				<div>
					<Card
						header={{
							title: t('labels.general'),
						}}
						type={CardLayoutType.SlimHeader}
						emptyBody
					>
						{status === 'pending' ? (
							<ContentLoader childHeight='6em' childCount={9} />
						) : status === 'error' ? (
							<ContentBlock error title={error.name} content={error.message} />
						) : (
							<>
								{data.manualActions.map((item: SettingsActionType) => (
									<div className='user-action' key={`preferencesManualAction${item.label}`}>
										<div className='fade'>{item.label}</div>
										<div>
											{typeof item.value === 'string'
												? item.value
												: item.value.map((entry: any) => (
														<div key={`settingsEntry${entry}`}>{entry}</div>
													))}
										</div>
									</div>
								))}
							</>
						)}
					</Card>
				</div>
			</StackVertical>
		</>
	);
}

export default BusinessDetails;
